import React, { use, useEffect, useMemo, useState } from 'react';
import { Phone, PhoneOff, X } from 'lucide-react';
import Pusher from "pusher-js";
import Api from "services/api"
import { useDispatch, useSelector } from 'react-redux';
import { userSelector } from 'slices/userSlice';
import { apiUrl } from 'services/config/secrets';
import echo from 'services/echo';
import { logout } from 'slices/userSlice';
import { useNavigate, useRoutes } from 'react-router-dom';
import toast from 'react-hot-toast';
import { SubmitButton } from './common/buttons/SubmitButton';
import { Spinner } from 'reactstrap';
import { setInterpreterIframeUrl } from 'slices/interpreter/interpreterIframeSlice';
const IncomingCallPopup = ({
  isVisible = true,
  callType = 'video', // 'video' or 'audio'
  language = 'Spanish',
  onAccept,
  onReject,
  onClose,
  callId,
  loading
}) => {
  if (!isVisible) return null;

  const handleAccept = () => {
    if (onAccept) {
      onAccept(callId);
    }
  };

  const handleReject = () => {
    if (onReject) {
      onReject();
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="algovi_vri_on_demand_overlay">
      <div className="algovi_vri_on_demand_popup">
        <div className="algovi_vri_on_demand_header">
          <button
            className="algovi_vri_on_demand_close_btn"
            onClick={handleClose}
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>

        <div className="algovi_vri_on_demand_call_info">
          <span className="algovi_vri_on_demand_call_type">
            Incoming {callType === 'video' ? 'Video' : 'Audio'} Call
          </span>
          <span className="algovi_vri_on_demand_language">{language}</span>
        </div>

        <div className="algovi_vri_on_demand_actions">
          <button
            className={`algovi_vri_on_demand_reject_btn ${loading ? "disabled-button" : ""}`}
            onClick={handleReject}
            disabled={loading}
          >
            <PhoneOff size={20} />
            <span>Reject</span>
          </button>

          <button
            className={`algovi_vri_on_demand_accept_btn ${loading ? "disabled-button" : ""} `}
            onClick={handleAccept}
            disabled={loading}
          >
            <Phone size={20} />
            <span>{"Accept"}</span>

            {loading && <Spinner size="sm">Loading...</Spinner>}
          </button>
          {/* <SubmitButton
            icon={
            <Phone size={20} />
            }
            onClick={handleAccept}
            btnText="Accept"
            buttonType="button"
            disabled={loading}
            loader={loading}
            className="green"
            style={{boxShadow: "none"}}


          /> */}
        </div>
      </div>

      <style jsx>{`
        .algovi_vri_on_demand_overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 20px;
        }

        .algovi_vri_on_demand_popup {
          background: #1a1a1a;
          border-radius: 20px;
          padding: 24px;
          width: 100%;
          max-width: 400px;
          color: white;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
          animation: algovi_vri_on_demand_slide_up 0.3s ease-out;
        }

        @keyframes algovi_vri_on_demand_slide_up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .algovi_vri_on_demand_header {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 20px;
        }

        .algovi_vri_on_demand_close_btn {
          background: none;
          border: none;
          color: #888;
          cursor: pointer;
          padding: 8px;
          border-radius: 50%;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .algovi_vri_on_demand_close_btn:hover {
          background: #333;
          color: white;
        }

        .algovi_vri_on_demand_call_info {
          text-align: center;
          margin-bottom: 32px;
        }

        .algovi_vri_on_demand_call_type {
          display: block;
          font-size: 16px;
          color: #ccc;
          margin-bottom: 8px;
        }

        .algovi_vri_on_demand_language {
          font-size: 24px;
          font-weight: 600;
          color: white;
        }

        .algovi_vri_on_demand_actions {
          display: flex;
          gap: 16px;
        }

        .algovi_vri_on_demand_reject_btn,
        .algovi_vri_on_demand_accept_btn {
          flex: 1;
          padding: 16px 24px;
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .algovi_vri_on_demand_reject_btn {
          background: #dc2626;
          color: white;
        }

        .algovi_vri_on_demand_reject_btn:hover {
          background: #b91c1c;
          transform: translateY(-1px);
        }

        .algovi_vri_on_demand_accept_btn {
          background: #16a34a;
          color: white;
        }

        .algovi_vri_on_demand_accept_btn:hover {
          background: #15803d;
          transform: translateY(-1px);
        }

        .algovi_vri_on_demand_reject_btn:active,
        .algovi_vri_on_demand_accept_btn:active {
          transform: translateY(0);
        }

        @media (max-width: 480px) {
          .algovi_vri_on_demand_popup {
            margin: 0 16px;
            padding: 20px;
          }
          
          .algovi_vri_on_demand_actions {
            flex-direction: column;
          }
          
          .algovi_vri_on_demand_reject_btn,
          .algovi_vri_on_demand_accept_btn {
            padding: 14px 20px;
          }
        }
      `}</style>
    </div>
  );
};

async function acceptVriCall(id) {

  try {
    const { data, status } = await Api.acceptVriCall(id)
    if (status === 200) {
      return {
        success: true,
        data
      }
    }
    return {
      success: false,
    }
  } catch (error) {
    console.log("error", error)
    return {
      success: false,
    }

  }
}

// IncomingCalls component showing both call types
const IncomingCalls = () => {
  const [showVideoCall, setShowVideoCall] = useState(false);
  // const [showAudioCall, setShowAudioCall] = useState(false);
  const [callType, setCallType] = useState("video")
  const [calls, setCalls] = useState({});
  const { user } = useSelector(userSelector)
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)




  const callDescription = useMemo(() => {
    return {
      callType, language: "French"
    }
  }, [])



  useEffect(() => {
    if (!user?.role?.includes("interpreter")) {
      return dispatch(logout())
    }
    // Initialize Pusher
    const channel = echo.channel(`interpreter.${user?.user?.id}`);
    // Subscribe to the private channel

    channel
      .listen(".incoming-call", (data) => {
        if (data?.callData?.id) {
          setShowVideoCall(true)
          setCalls(data?.callData || {});
        }
      }).error((error) => {
        console.log("Failed to listen to the channel.", error);
      })

    return () => {
      channel.stopListening(".incoming-call");
    }

  }, [echo, user]);

  const resetAllFields = () => {
    setShowVideoCall(false);
    setCalls({})
    // setShowAudioCall(false);

  }


  const handleAccept = async (callId) => {
    setLoading(true)
    const { data, success } = await acceptVriCall(callId)
    if (success) {
      resetAllFields()
      setLoading(false)
      // const iframeUrl = data?.iframe_url;
      // dispatch(setIframeUrl(data?.iframe_url));
      dispatch(setInterpreterIframeUrl(data?.iframe_url));
      

      navigate(`/interpreter/appointments/view/${data.appointment?.id}/join-room-call`)
    }
    else {
      setLoading(false)
      resetAllFields()
      toast.error("Appointment Not Found", {
        className: "errorToast",
      }
      );
    }

  };

  const handleReject = () => {
    console.log('Call rejected - integrate with your API here');
    // Your API call here
    setShowVideoCall(false);
    // setShowAudioCall(false);
  };

  const handleClose = () => {
    setShowVideoCall(false);
    // setShowAudioCall(false);
  };

  return (
    <IncomingCallPopup
      isVisible={showVideoCall}
      callType={callDescription.callType}
      language={calls.language}
      onAccept={handleAccept}
      onReject={handleReject}
      onClose={handleClose}
      callId={calls?.id}
      loading={loading}
    />
  );
};

export default IncomingCalls;